export type TopbarSection = 'home' | 'matches' | 'players' | 'watch' | 'meta' | 'start' | null

const sectionByRouteName: Record<string, Exclude<TopbarSection, null>> = {
  home: 'home',
  matches: 'matches',
  'match-detail': 'matches',
  players: 'players',
  'player-profile': 'players',
  'live-matches': 'watch',
  'live-match-detail': 'watch',
  'hero-stats': 'meta',
  'hero-profile': 'meta',
  'patch-classic': 'meta',
  'patch-actual': 'meta',
  'item-stats': 'meta',
  start: 'start',
}

export function topbarSectionForRouteName(routeName: unknown): TopbarSection {
  return typeof routeName === 'string' ? sectionByRouteName[routeName] ?? null : null
}

export function formatLiveBroadcastCount(count: number): string {
  if (!Number.isFinite(count) || count <= 0) return '0'
  const wholeCount = Math.floor(count)
  return wholeCount > 99 ? '99+' : String(wholeCount)
}
